/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApplicantAddressCreateDto } from '../models/ApplicantAddressCreateDto';
import type { ApplicantAddressCreateResult } from '../models/ApplicantAddressCreateResult';
import type { ApplicantContactsCreateDto } from '../models/ApplicantContactsCreateDto';
import type { ApplicantEmploymentCreateDto } from '../models/ApplicantEmploymentCreateDto';
import type { BankAccountCreateResult } from '../models/BankAccountCreateResult';
import type { BankAccountDetailsCreateDto } from '../models/BankAccountDetailsCreateDto';
import type { EmploymentAddressCreateDto } from '../models/EmploymentAddressCreateDto';
import type { EmploymentAddressCreateResult } from '../models/EmploymentAddressCreateResult';
import type { EmploymentCreateResult } from '../models/EmploymentCreateResult';
import type { FinanceDictionaryDto } from '../models/FinanceDictionaryDto';
import type { FinanceProposalDto } from '../models/FinanceProposalDto';
import type { IndividualApplicantDto } from '../models/IndividualApplicantDto';
import type { IndividualResultDto } from '../models/IndividualResultDto';
import type { LenderTypeEnum } from '../models/LenderTypeEnum';
import type { ProposalApplicantCreateDto } from '../models/ProposalApplicantCreateDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class FinanceProposalService {

  /**
   * @param lender
 *
 * 1 = Encore
 *
 * 2 = Genus
 *
 * 3 = Santander
   * @returns FinanceDictionaryDto Success
   * @throws ApiError
   */
  public static getProposalsIndividualDictionaries(
lender?: LenderTypeEnum,
): CancelablePromise<FinanceDictionaryDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/proposals/individual/dictionaries',
      query: {
        'lender': lender,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param proposalId 
   * @returns FinanceProposalDto Success
   * @throws ApiError
   */
  public static getProposalsIndividual(
proposalId: number,
): CancelablePromise<FinanceProposalDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/proposals/individual/{proposalId}',
      path: {
        'proposalId': proposalId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param dealId 
   * @returns FinanceProposalDto Success
   * @throws ApiError
   */
  public static getProposalsIndividualByDeal(
dealId: number,
): CancelablePromise<FinanceProposalDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/proposals/individual/by-deal/{dealId}',
      path: {
        'dealId': dealId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param dealId 
   * @param requestBody 
   * @returns IndividualResultDto Success
   * @throws ApiError
   */
  public static postProposalsIndividualByDeal(
dealId: number,
requestBody?: ProposalApplicantCreateDto,
): CancelablePromise<IndividualResultDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/proposals/individual/by-deal/{dealId}',
      path: {
        'dealId': dealId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param proposalId 
   * @param requestBody 
   * @returns IndividualResultDto Success
   * @throws ApiError
   */
  public static postProposalsIndividualApplicants(
proposalId: number,
requestBody?: ProposalApplicantCreateDto,
): CancelablePromise<IndividualResultDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/proposals/individual/{proposalId}/applicants',
      path: {
        'proposalId': proposalId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param applicantId 
   * @param requestBody 
   * @returns void 
   * @throws ApiError
   */
  public static putProposalsIndividualApplicants(
applicantId: number,
requestBody?: ProposalApplicantCreateDto,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/proposals/individual/applicants/{applicantId}',
      path: {
        'applicantId': applicantId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param applicantId 
   * @param requestBody 
   * @returns IndividualApplicantDto Success
   * @throws ApiError
   */
  public static putProposalsIndividualApplicantsContact(
applicantId: number,
requestBody?: ApplicantContactsCreateDto,
): CancelablePromise<IndividualApplicantDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/proposals/individual/applicants/{applicantId}/contact',
      path: {
        'applicantId': applicantId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param applicantId 
   * @param requestBody 
   * @returns ApplicantAddressCreateResult Success
   * @throws ApiError
   */
  public static postProposalsIndividualApplicantsAddresses(
applicantId: number,
requestBody?: ApplicantAddressCreateDto,
): CancelablePromise<ApplicantAddressCreateResult> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/proposals/individual/applicants/{applicantId}/addresses',
      path: {
        'applicantId': applicantId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param addressId 
   * @param requestBody 
   * @returns void 
   * @throws ApiError
   */
  public static putProposalsIndividualApplicantsAddresses(
addressId: number,
requestBody?: ApplicantAddressCreateDto,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/proposals/individual/applicants/addresses/{addressId}',
      path: {
        'addressId': addressId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param applicantId 
   * @param requestBody 
   * @returns EmploymentCreateResult Success
   * @throws ApiError
   */
  public static postProposalsIndividualApplicantsEmployments(
applicantId: number,
requestBody?: ApplicantEmploymentCreateDto,
): CancelablePromise<EmploymentCreateResult> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/proposals/individual/applicants/{applicantId}/employments',
      path: {
        'applicantId': applicantId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param employmentId 
   * @param requestBody 
   * @returns void 
   * @throws ApiError
   */
  public static putProposalsIndividualApplicantsEmployments(
employmentId: number,
requestBody?: ApplicantEmploymentCreateDto,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/proposals/individual/applicants/employments/{employmentId}',
      path: {
        'employmentId': employmentId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param employmentId 
   * @param requestBody 
   * @returns EmploymentAddressCreateResult Success
   * @throws ApiError
   */
  public static postProposalsIndividualApplicantsEmploymentsAddress(
employmentId: number,
requestBody?: EmploymentAddressCreateDto,
): CancelablePromise<EmploymentAddressCreateResult> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/proposals/individual/applicants/employments/{employmentId}/address',
      path: {
        'employmentId': employmentId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param addressId 
   * @param requestBody 
   * @returns void 
   * @throws ApiError
   */
  public static putProposalsIndividualApplicantsEmploymentsAddresses(
addressId: number,
requestBody?: EmploymentAddressCreateDto,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/proposals/individual/applicants/employments/addresses/{addressId}',
      path: {
        'addressId': addressId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param applicantId 
   * @param requestBody 
   * @returns BankAccountCreateResult Success
   * @throws ApiError
   */
  public static postProposalsIndividualApplicantsBankAccount(
applicantId: number,
requestBody?: BankAccountDetailsCreateDto,
): CancelablePromise<BankAccountCreateResult> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/proposals/individual/applicants/{applicantId}/bank-account',
      path: {
        'applicantId': applicantId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param bankAccountId 
   * @param requestBody 
   * @returns void 
   * @throws ApiError
   */
  public static putProposalsIndividualApplicantsBankAccounts(
bankAccountId: number,
requestBody?: BankAccountDetailsCreateDto,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/proposals/individual/applicants/bank-accounts/{bankAccountId}',
      path: {
        'bankAccountId': bankAccountId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

}
